import { render, staticRenderFns } from "./NavBarProfile.vue?vue&type=template&id=57dcd596&"
import script from "./NavBarProfile.vue?vue&type=script&lang=js&"
export * from "./NavBarProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports